import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { TemplateNames } from '@/shared/lib/constants'

export const editMessageTemplateFormScheme = (t: TFunction) => {
  return Yup.object({
    name: Yup.mixed()
      .oneOf(Object.values(TemplateNames) as string[], t('common:validation_messages.required'))
      .required(t('common:validation_messages.required')),
    content: Yup.string()
      .min(12, t('common:validation_messages.min', { count: 12 }))
      .required(t('common:validation_messages.required')),
    comment: Yup.string().max(256, t('common:validation_messages.max', { count: 256 })),
    subject: Yup.string().max(100, t('common:validation_messages.max', { count: 100 })),
  })
}

export const editMessageTemplateFormDefault = {
  name: '',
  comment: '',
  content: '',
  subject: '',
}
